var map = {
	"./coin_lvl_1.png": 5200,
	"./coin_lvl_2.png": 3745,
	"./coin_small.png": 4624,
	"./coin_w_lvl_1.png": 3107,
	"./coin_w_lvl_2.png": 8336,
	"./coin_w_lvl_3.png": 6449,
	"./coin_w_lvl_4.png": 1253,
	"./crown": 5137,
	"./crown.json": 5137,
	"./crown.png": 919,
	"./energy.png": 7326,
	"./fire": 1521,
	"./fire.json": 1521,
	"./fire.png": 3548,
	"./football-club.png": 352,
	"./gold": 3123,
	"./gold.json": 3123,
	"./grams.png": 5624,
	"./hourglass.png": 7675,
	"./medal.png": 9142,
	"./rect_light.png": 9645,
	"./rect_light.svg": 7142,
	"./scroll.png": 1306,
	"./shirts": 4017,
	"./shirts.json": 4017,
	"./spellbook.png": 642,
	"./standard.png": 7587,
	"./top-10.png": 8871,
	"./top-5.png": 5373,
	"./trophy.png": 7826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;